module.exports = __webpack_public_path__ + "img/facebook-d.616417cd.svg";